var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "md-card",
        { staticClass: "request-status" },
        [
          _c("md-card-content", [
            _c("div", { staticClass: "text-center" }, [
              !_vm.message.length
                ? _c("h4", [_vm._v("checking...")])
                : _vm._e(),
              _vm._v(" "),
              _c("h4", { attrs: { else: "" } }, [_vm._v(_vm._s(_vm.message))])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e40fc52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e40fc52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigureOutlook.vue
// module id = null
// module chunks = 